"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AssetsLoader;

var _react = _interopRequireDefault(require("react"));

var _commonReact = require("@devsta/common-react");

var _reactSizeme = require("react-sizeme");

require("../styles/_assets-loader.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var LOADER_ASSET_SIZE = 190;
var LOADER_ASSET_MARGIN = 20;

function AssetsLoader() {
  return (/*#__PURE__*/_react.default.createElement(_reactSizeme.SizeMe, null, function (_ref) {
      var _ref$size$width = _ref.size.width,
          width = _ref$size$width === void 0 ? 0 : _ref$size$width;
      var numberOfLoadingItems = Math.floor(width / (LOADER_ASSET_SIZE + LOADER_ASSET_MARGIN));
      return (/*#__PURE__*/_react.default.createElement("div", {
          className: "assets-loader"
        }, /*#__PURE__*/_react.default.createElement(_commonReact.ContentLoader, {
          height: 150,
          width: "100%"
        }, _toConsumableArray(Array(numberOfLoadingItems)).map(function (_, index) {
          return (/*#__PURE__*/_react.default.createElement("rect", {
              // We're never going to have unique identifiers here as every item is the same
              // eslint-disable-next-line
              key: index,
              x: index * (LOADER_ASSET_SIZE + LOADER_ASSET_MARGIN),
              y: "0",
              rx: "2",
              ry: "2",
              width: LOADER_ASSET_SIZE,
              height: "150"
            })
          );
        })))
      );
    })
  );
}